<template>
    <div class="p-grid voucher-page">
        <div class="p-col-4">
            <div class="card add-voucher">
                <Toast />
                <h2>Add Voucher</h2>
                <div class="form-item">
                    <label for="label">Label </label>
                    <InputText id="label" placeholder="" v-model="label" />
                </div>
                <div class="form-item">
                    <label for="users">Number of uses</label>
                    <InputText id="users" placeholder="" v-model="number_of_uses" />
                </div>
                <div class="form-item">
                    <label for="time24">Valid until</label>
                    <Calendar id="time24" v-model="valid_till" :showTime="true" :showSeconds="false" />
                </div>
                <div class="form-item">
                    <label for="discount">Discount percentage</label>
                    <InputText id="discount" placeholder="" v-model="discount_pct" />
                </div>
                <div class="form-item">
                    <label for="discount-abs">Discount absolute</label>
                    <InputText id="discount-abs" placeholder="" v-model="discount_abs" />
                </div>
                <div class="form-item">
                    <label for="levels">Upgrade levels</label>
                    <InputText id="levels" placeholder="" v-model="upgrade_range" />
                </div>
                

                <div class="form-action">
                    <Button @click="addVoucher()" :disabled="buttonDisable" label="Add voucher" />
                </div>
            </div>
        </div>

        <div class="p-col-8">
            <div class="data-table data-table-list">
                <DataTable :value="vouchers" class="p-datatable-responsive">
                    <template #header>
                        <h2>List of vouchers</h2>
                    </template>
                    <Column field="label" header="Label" :sortable="true">
                        <template #body="slotProps">
                            <span>{{ slotProps.data.label }}</span>
                        </template>
                    </Column>
                    <Column field="number_of_uses" header="Number of uses" :sortable="true">
                        <template #body="slotProps">
                            <span>{{ slotProps.data.number_of_uses }}</span>
                        </template>
                    </Column>
                    <Column field="valid_till" header="Valid until" :sortable="true">
                        <template #body="slotProps">
                            <span>{{ formatDate(slotProps.data.valid_till) }}</span>
                        </template>
                    </Column>
                    <Column field="discount_pct" header="Discount pct" :sortable="true">
                        <template #body="slotProps">
                            <span>{{ slotProps.data.discount_pct }}</span>
                        </template>
                    </Column>
                    <Column field="discount_abs" header="Discount abs" :sortable="true">
                        <template #body="slotProps">
                            <span>{{ slotProps.data.discount_abs }}</span>
                        </template>
                    </Column>
                    <Column field="upgrade_range" header="Upgrade range" :sortable="true">
                        <template #body="slotProps">
                            <span>{{ slotProps.data.upgrade_range }}</span>
                        </template>
                    </Column>
                </DataTable>
            </div>
        </div>
    </div>
</template>




<script>
    import PurchaseService from '../../service/PurchaseService';
    export default {
        data() {
            return {
                label: '',
                number_of_uses: 1,
                valid_till: null,
                discount_pct: 0,
                discount_abs: 0,
                upgrade_range: 0,
                buttonDisable: false,
                vouchers: [],
                filters: [],


            };
        },
        created() {
            this.$store.commit('setPageTitle', {pageTitle: 'Vouchers'});
            this.purchaseService = new PurchaseService();

        },
        async mounted() {

            this.getVouchers();
        },
        methods: {
            async  addVoucher() {
                await this.purchaseService.addVoucher(this.label, this.number_of_uses, this.valid_till, this.discount_pct, this.discount_abs, this.upgrade_range, this.$store.state.currentUser.token);
                this.getVouchers();
            },
            async  getVouchers() {
                var temp = await this.purchaseService.getVouchers(this.$store.state.currentUser.token);

                this.vouchers = temp.data.data;
                console.log(temp);
            },
              formatDate(date) {
            var d = new Date(date),
                month = "" + (d.getMonth() + 1),
                day = "" + d.getDate(),
                year = d.getFullYear(),
                hours = "" + d.getHours(),
                mins = "" + d.getMinutes();

            if (month.length < 2) month = "0" + month;
            if (day.length < 2) day = "0" + day;
            if (hours.length < 2) hours = "0" + hours;
            if (mins.length < 2) mins = "0" + mins;

            return [year, month, day].join("-") + " " + hours + ":" + mins;
        },

        }
    };
</script>

<style scoped>
    .sb-option {
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 16px;
        margin-bottom: 22px;
    }

    .sb-option3 {
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 16px;
        margin-top: 24px;
    }

    button {
        margin-left: 20px;
    }
</style>